import '../input.scss';
import '../inputs-v1-1.scss';

import React from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { FileInputProps } from './fileInputSchema';

export const UploadButton = observer(
  ({
    accept,
    'aria-label': ariaLabel,
    className,
    disabled,
    id,
    label,
    layoutSize,
    multiple,
    name,
    onChange,
  }: FileInputProps) => {
    className = classNames('btn btn-core primary btn-outline text-btn file-input-btn-upload', //className
    className,
    layoutSize, 
    {
      disabled: disabled
    });

    return (
      <button className={className} type="button">
        <input type="file"
          aria-label={ariaLabel}
          className="widget-upload-file-input"
          accept={accept}
          disabled={disabled}
          id={id}
          multiple={multiple}
          name={name}
          onChange={evt => onChange?.(evt)} />
        <div className="text">{label}</div>
      </button>)
  });
